module.exports = __webpack_public_path__ + "static/media/left-button-off.5bdea325.png";